import { createFileRoute } from '@tanstack/react-router';

import Page from '@/screens/chat/agents/page';

export const Route = createFileRoute('/_app/_chat/agents/')({
  component: Page,
});
